import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CardAmexIcon = createIcon({
  displayName: 'CardAmexIcon',
  viewBox: '0 0 32 20',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "19",
    rx: "1.5",
    stroke: "currentColor",
    width: "31",
    x: "0.5",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90103 7L3.5 13H4.95481L5.42734 11.6364H8.15541L8.62793 13H11.356V8.5L13.1018 13H14.375L16.1557 8.63636V13H17.4301V7H15.355L13.7535 11.0582L12.1556 7H9.90119V12.6945L7.64564 7H5.90103ZM18.5712 7V13H23.6968L25.2971 11.0582L26.8962 13H28.5L26.099 10L28.5 7H26.7542L25.1539 8.80655L23.8446 7H18.5712ZM6.70059 8.19345L7.50132 10.3065H5.89986L6.70059 8.19564V8.19345ZM19.8444 8.36364H23.045L24.3544 10L22.8995 11.8065H19.8444V10.6142H22.7541V9.38691H19.8444V8.36364Z",
    fill: "currentColor"
  }))
});
//# sourceMappingURL=CardAmex.js.map